/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
/**
 * Supported languages
 *
 * Values must be compatible with lang attribute: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/lang
 */
export var Language;
(function (Language) {
    Language["English"] = "en";
    Language["French"] = "fr";
})(Language || (Language = {}));
export const SupportedLanguages = Object.values(Language);
export const FallbackLang = Language.English;
export function isLangSupported(lang) {
    return Object.values(Language).includes(lang);
}
export function langFromString(lang) {
    return Object.values(Language).find((l) => l === lang);
}
//# sourceMappingURL=Language.js.map